export default "<app-home-view-container></app-home-view-container>\r\n";